import common from "../../../utils/common";
import env from "../../../utils/env";

class userBasicDetailsController {
  constructor(UsersService, NotificationService, AppContextService) {
    "ngInject"

    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;
    this.imageBaseUrl = env.getStorageUrl() + "images/";
    this.videoBaseUrl = "//jugglestreet.wistia.com/medias/";

    this.editMode = {
      firstName: {
        active: false,
        value: "",
      },
      lastName: {
        active: false,
        value: "",
      },
      email: {
        active: false,
        value: "",
      },
      phoneNumber: {
        active: false,
        value: "",
      },
      dateOfBirth: {
        active: false,
        value: "",
        isLoading: false,
      },
      affiliateCode: {
        active: false,
        value: "",
        isLoading: false,
      },
    }

    this.datePickerOptions = {
      format: "dd/MM/yyyy"
    }
  }

  enableEditMode(field) {
    this.editMode[field].active = true;

    // Save the field incase if you want to revert the changes
    this.editMode[field].value = this.user[field];
  }

  disableEditMode(field) {
    this.editMode[field].active = false;

    // Revert the changes
    this.user[field] = this.editMode[field].value;
  }

  saveDetails(field) {
    this.editMode[field].isLoading = true;
    let payload = Object.assign({}, this.user);

    if(field == "dateOfBirth") {
      let arr = payload.dateOfBirth.split("/");

      payload.dateOfBirthDay = parseInt(arr[0]);
      payload.dateOfBirthMonth = parseInt(arr[1]);
      payload.dateOfBirthYear = parseInt(arr[2]);
    }

    this.usersService.updateUserDetails(
        this.user.userId,
        payload,
        (response) => {
          this.editMode[field].isLoading = false;
          this.editMode[field].active = false;
          this.notificationService.success("Update Successful");
          this.user = response.data;
        },
        (error) => {
          this.notificationService.error("Update Failed");
          this.editMode[field].isLoading = false;
        });
  }

  formatDate(date) {
    if(!date) return "-";

    return common.formatDate(date, "DD/MM/YYYY");
  }

  hasPaymentsAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasPaymentsAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

}

export default userBasicDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-basic-details/user-basic-details.controller.js
 **/